const module = { name: 'about/giftCards/desktop.app', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from 'require-core';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_carousel as fdCarousel } from 'require-global';



const Selectors = {
    GIFT_CARDS: '.js-gift-card-carousel',
    CUSTOM_GIFT_CARDS: '.js-custom-gift-card-carousel'
}
function run() {
    checkDependencies(module.name, debugLog);
    const giftCardCarousels = document.querySelectorAll(Selectors.GIFT_CARDS);
    giftCardCarousels.forEach((carousel) => {
        fdCarousel.init(carousel.id, {
            gap: 10,
            perPage: 4
        });
    });
    const customGiftCardCarousels = document.querySelectorAll(Selectors.CUSTOM_GIFT_CARDS);
    customGiftCardCarousels.forEach((carousel) => {
        fdCarousel.init(carousel.id, {
            gap: 10,
            padding: { left: 0, right: 0 },
            perPage: 2
        });
    });
}
run();
export default module.exports;